import { lazy } from "react";

export const ContactPage = lazy(() => import("../../Features/Contact"));
